import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "page-load"

  connect() {
    super.connect()
    this.send("connect")
  }
}
